const macronutrient_sp = {
    'carbohydrate': {
        'Bacillus genus': 0,
        'Candida albicans': 0,
        'Clostridium difficile': 0,
        'Escherichia coli': 0,
        'Staphylococcus aureus': 0,
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 0.5,
        'Bacteroides genus': 1,
        'Bacteroides fragilis': 0.25,
        'Faecalibacterium prausnitzii': 1,
        'Roseburia hominis': 0.25,
        'Bifidobacterium bifidum': 0.5,
        'Bifidobacterium breve': 0.5,
        'Bifidobacterium lactis': 0.5,
        'Bifidobacterium longum': 1
    },
    'protein': {
        'Bacillus genus': 1,
        'Candida albicans': 0,
        'Clostridium difficile': 1,
        'Escherichia coli': 1,
        'Staphylococcus aureus': 1,
        'Akkermansia muciniphila': 0,
        'Alistipes putredinis': 0.25,
        'Bacteroides genus': 0.25,
        'Bacteroides fragilis': 0.25,
        'Faecalibacterium prausnitzii': 0,
        'Roseburia hominis': 0,
        'Bifidobacterium bifidum': 0,
        'Bifidobacterium breve': 0,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium longum': 0
    },
    'lipid': {
        'Bacillus genus': 1,
        'Candida albicans': 0,
        'Clostridium difficile': 0,
        'Escherichia coli': 1,
        'Staphylococcus aureus': 1,
        'Akkermansia muciniphila': -1,
        'Alistipes putredinis': 0.25,
        'Bacteroides genus': 0.25,
        'Bacteroides fragilis': 0,
        'Faecalibacterium prausnitzii': 0,
        'Roseburia hominis': 0,
        'Bifidobacterium bifidum': 0,
        'Bifidobacterium breve': 0,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium longum': 0
    },
}

const macronutrient_multi = {
    case1: {
        score_cal: 1,
        multiply: 0.25
    },
    case2: {
        score_cal: 2,
        multiply: 0.5
    },
    case3: {
        score_cal: 3,
        multiply: 1
    },
    othercase: {
        multiply: 0
    },
}

const macronutrient_harmfulsp = [
    'Bacillus genus',
    'Candida albicans',
    'Clostridium difficile',
    'Escherichia coli',
    'Staphylococcus aureus'
]

const macronutrientharmful_multi = {
    case1: {
        score_cal: 5,
        multiply: 1
    },
    case2: {
        score_cal: 4,
        multiply: 1
    },
    case3: {
        score_cal: 3,
        multiply: 0
    },
    othercase: {
        multiply: 0
    },
}

const macronutrient_spCondition = {
    carbohydrate: {
        page: 39,
        XposText: 547,
        YposText: 402,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 121,
        YposImage: 360,
        xBarStart: 204,
        YBarStart: 407,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 3.9,
                score: 3,
                label: 'Optimum',
                image: 'ca3',
            },
            {
                condition: (x) => (0.975 < x) && (x < 3.9),
                score: 2,
                label: 'Slightly below optimum',
                image: 'ca2',
            },
            {
                condition: (x) => x <= 0.975,
                score: 1,
                label: 'Below optimum',
                image: 'ca1',
            }
        ]
    },
    protein: {
        page: 39,
        XposText: 547,
        YposText: 498,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 121,
        YposImage: 456,
        xBarStart: 204,
        YBarStart: 503,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 2.85,
                score: 5,
                label: 'Above optimum',
                image: 'pr5',
            },
            {
                condition: (x) => (1 < x) && (x < 2.85),
                score: 4,
                label: 'Slightly above optimum',
                image: 'pr4',
            },
            {
                condition: (x) => x <= 1,
                score: 3,
                label: 'Optimum',
                image: 'pr3',
            }
        ]
    },
    lipid: {
        page: 39,
        XposText: 547,
        YposText: 592,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 125,
        YposImage: 549,
        xBarStart: 204,
        YBarStart: 597,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 1.5,
                score: 5,
                label: 'Above optimum',
                image: 'fat5',
            },
            {
                condition: (x) => (0.375 < x) && (x < 1.5),
                score: 4,
                label: 'Slightly above optimum',
                image: 'fat4',
            },
            {
                condition: (x) => x <= 0.375,
                score: 3,
                label: 'Optimum',
                image: 'fat3',
            }
        ]
    }
}

const macronutrient_spCondition_thai = {
    carbohydrate: {
        page: 38,
        XposText: 515,
        YposText: 444,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 399,
        xBarStart: 177,
        YBarStart: 455,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 3.9,
                score: 3,
                label: 'เหมาะสม',
                image: 'ca3',
            },
            {
                condition: (x) => (0.975 < x) && (x < 3.9),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'ca2',
            },
            {
                condition: (x) => x <= 0.975,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'ca1',
            }
        ]
    },
    protein: {
        page: 38,
        XposText: 515,
        YposText: 542,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 499,
        xBarStart: 177,
        YBarStart: 552,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 2.85,
                score: 5,
                label: 'สูงกว่าระดับที่เหมาะสม',
                image: 'pr5',
            },
            {
                condition: (x) => (1 < x) && (x < 2.85),
                score: 4,
                label: 'สูงกว่ากว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'pr4',
            },
            {
                condition: (x) => x <= 1,
                score: 3,
                label: 'เหมาะสม',
                image: 'pr3',
            }
        ]
    },
    lipid: {
        page: 38,
        XposText: 515,
        YposText: 648,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 78,
        YposImage: 606,
        xBarStart: 177,
        YBarStart: 658,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 1.5,
                score: 5,
                label: 'สูงกว่าระดับที่เหมาะสม',
                image: 'fat5',
            },
            {
                condition: (x) => (0.375 < x) && (x < 1.5),
                score: 4,
                label: 'สูงกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'fat4',
            },
            {
                condition: (x) => x <= 0.375,
                score: 3,
                label: 'เหมาะสม',
                image: 'fat3',
            }
        ]
    }
}

export { macronutrient_sp, macronutrient_multi, macronutrient_harmfulsp, macronutrientharmful_multi, macronutrient_spCondition, macronutrient_spCondition_thai };